import React, {FunctionComponent} from "react";
import IconButton from "./IconButton";
import {faInstagram} from "@fortawesome/free-brands-svg-icons";

export const InstagramButton: FunctionComponent<{resource: any}> = ({resource}) => {
	return resource && resource.social.instagram
			? resource._object === 'Organization'
				? <a href={`https://instagram.com/${resource.social.instagram}`} target='_blank' rel="noreferrer">
					<IconButton
						size={'xs'}
						iconSize={'lg'}
						fillColor={'cyan'}
						icon={faInstagram as any}
					/>
				</a>
				: <a href={`https://instagram.com/${resource.social.instagram.username}`} target='_blank' rel="noreferrer">
					<IconButton
						size={'xs'}
						iconSize={'lg'}
						fillColor={'cyan'}
						icon={faInstagram as any}
					/>
				</a> : null;
}

export default InstagramButton;
